import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import NavbarApp from '../header/NavbarApp'
import { BackgroundColor } from '../styled_components/BackgroundColor'
import { routes } from '../../constantes/routes'

import Main from '../main/Main'
import SearchCompareContainer from '../search-v2/SearchCompareContainer'
import ProductsSearchHost from '../search-v2/ProductsSearchHost'
import CatalogueSearchHost from '../search-v2/CatalogueSearchHost'

import ContactsHospitalsContainer from '../contacts/ContactsHospitalsContainer'
import NewContactContainer from '../contacts/contacts/new-contact/NewContactContainer'
import AddHospitalToContactContainer from '../contacts/contactHospitals/add-hospitalToContact/AddHospitalToContactContainer'
import ContactAndTheirHospitalsDetailContainer from '../contacts/contactHospitals/contact-hospitals-detail/ContactAndTheirHospitalsDetailContainer'
import EditContactHospitalsContainer from '../contacts/contactHospitals/edit-contact-hospitals/EditContactHospitalsContainer'
import EditContactHospitalDetails from '../contacts/contactHospitals/edit-contact-hospitals/EditContactHospitalDetails'
import EditCOntactDetails from '../contacts/contactHospitals/edit-contact-hospitals/EditContactDetails'

import BackOffice from '../backoffice/BackOffice'

import Profile from '../profile/ProfileContainer'
import ChangePasswordProfile from '../profile/ResetPasswordContainer'

import ProductsContainer from '../backoffice/products/ProductsContainer'
import NewProductsContainer from '../backoffice/products/new-products/NewProductsContainer'
import EditProductsContainer from '../backoffice/products/edit-products/EditProductsContainer'

import HospitalsContainer from '../backoffice/hospitals/HospitalsContainer'
import NewHospitalContainer from '../backoffice/hospitals/new-hospital/NewHospitalContainer'
import EditHospitalContainer from '../backoffice/hospitals/edit-hospital/EditHospitalContainer'

import DepartamentsContainer from '../backoffice/departments/DepartamentsContainer'
import PositionsContainer from '../backoffice/positions/PositionsContainer'
import SpecialtiesContainer from '../backoffice/specialties/SpecialtiesContainer'
import CategoriesContainer from '../backoffice/categories/CategoriesContainer'

import ConfigContaimer from '../backoffice/config/ConfigContainer'

import NewUserContainer from '../backoffice/users/new-user/NewUserContainer'
import EditUserContainer from '../backoffice/users/edit-user/EditUserContainer'
import UsersContainer from '../backoffice/users/UsersContainer'

import ManagementContainer from '../management/ManagementContainer'
import ViewTaskContainer from '../management/tasks/view-task/ViewTaskContainer'
import NewTaskContainer from '../management/tasks/new-task/NewTaskContainer'
import EditTaskContainer from '../management/tasks/edit-task/EditTaskContainer' // Ahora es un modal
import CalendarContainer from '../calendar/CalendarContainer'


import PresentationContainer from '../presentation/PresentationContainer'
import EditPresentationContainer from '../presentation/edit-presentation/EditPresentationContainer'
import AddProductToThePresentationFromTheCatalog from '../presentation/AddProductToThePresentationFromTheCatalog'

import ViewPresentationContainer from '../presentation/view-presentation/ViewPresentationContainer'
import { BreadcrumbProvider } from '../common/Breadcrumb'
import PageNotFound from '../pageNotFound/PageNotFound'
import BusinessUnitsContainer from '../backoffice/businessunits/BusinessUnitsContainer'
import EventosContainer from '../eventos/EventosContainer'
import SeguimientoComercialContainer from '../eventos/seguimiento/SeguimientoComercialContainer'
import ViewSeguimientoComercialContainer from '../eventos/seguimiento/ViewSeguimientoComercialContainer'

const AppContainer = () => {
  
  const userProfile = useSelector((state) => state.userProfile)

  const backgroundColorUser =
    userProfile && userProfile.tipoColores != null
      ? userProfile.tipoColores.codigoColor
      : null

  return (
    <>
      <BackgroundColor color={backgroundColorUser} />
      <NavbarApp />
      <Switch>
        {/* Main */}
        {/* <Route path={routes.LANDING} component={Main} /> */}
        <Route path={routes.MAIN} component={Main} />
        {/* Backoffice*/}
        <Route exact path={routes.BACKOFFICE} component={BackOffice} />
        {/* Profile */}
        <Route
          exact
          path={routes.CHANGE_PASSWORD_PROFILE + ':id'}
          component={ChangePasswordProfile}
        />
        <Route exact path={routes.PROFILE + ':id'} component={Profile} />
        {/* Usuarios */}
        <Route path={routes.USER_NEW} component={NewUserContainer} />
        <Route path={routes.USER_EDIT + ':id'} component={EditUserContainer} />
        <Route path={routes.USERS} component={UsersContainer} />
        {/* Categories */}
        <Route exact path={routes.CATEGORIES} component={CategoriesContainer} />
        <Route path={routes.POSITIONS} component={PositionsContainer} />
        <Route path={routes.DEPARTMENTS} component={DepartamentsContainer} />
        <Route path={routes.SPECIALTIES} component={SpecialtiesContainer} />
        {/* Hospitales */}
        <Route exact path={routes.HOSPITALS} component={HospitalsContainer} />
        <Route
          exact
          path={routes.HOSPITAL_EDIT + ':id'}
          component={EditHospitalContainer}
        />
        <Route
          exact
          path={routes.HOSPITAL_NEW}
          component={NewHospitalContainer}
        />
        {/* Articulos */}
        {/* ProductsSearchHost decide, según Configuraciones, si se pinta
            ProductsContainer (el de siempre, sin tocar), el motor v2 o ambos. */}
        <Route exact path={routes.PRODUCTS} component={ProductsSearchHost} />
        <Route
          exact
          path={routes.PRODUCTS_NEW}
          component={NewProductsContainer}
        />
        <Route
          exact
          path={routes.PRODUCTS_EDIT + ':id'}
          component={EditProductsContainer}
        />
        <Route
          exact
          path={routes.CONFIGURACIONES}
          component={ConfigContaimer}
        />
        {/* Management*/}
        <Route exact path={routes.MANAGEMENT} component={ManagementContainer} />
        <Route path={routes.TASK_EDIT + ':id'} component={EditTaskContainer} />
        {/* <Route path={routes.TASK_NEW} component={NewTaskContainer} /> */}
        <Route path={routes.TASK_VIEW + ':id'} component={ViewTaskContainer} />
        {/* Presentations*/}
        <Route
          exact
          path={routes.PRESENTATION}
          component={PresentationContainer}
        />
        <Route
          path={routes.PRESENTATION_EDIT + ':id'}
          component={EditPresentationContainer}
        />
        <Route
          path={routes.PRESENTATION_VIEW + ':id'}
          component={ViewPresentationContainer}
        />
        {/* Contacts */}
        <Route
          exact
          path={routes.CONTACTS}
          component={ContactsHospitalsContainer}
        />
        <Route
          exact
          path={routes.CONTACT_NEW}
          component={NewContactContainer}
        />
        <Route
          path={routes.CONTACTS_ADD_HOSPITAL_TO_CONTACT + ':id'}
          component={AddHospitalToContactContainer}
        />
        <Route
          path={routes.CONTACT_DETAIL + ':id'}
          component={ContactAndTheirHospitalsDetailContainer}
        />
        <Route
          path={routes.CONTACT_EDIT_CONTACT_HOSPITAL + ':id'}
          component={EditContactHospitalDetails}
        />
        <Route
          path={routes.CONTACT_EDIT_CONTACT + ':id'}
          component={EditCOntactDetails}
        />
        <Route
          path={routes.CONTACT_EDIT + ':id'}
          component={EditContactHospitalsContainer}
        />
        {/* Calendar */}
        <Route path={routes.CALENDAR} component={CalendarContainer} />
        <Route path={routes.BUSINESSUNITS} component={BusinessUnitsContainer} />
        <Route path={routes.EVENTOS} component={EventosContainer} />
        <Route
          path={routes.SEGUIMIENTO_COMERCIAL}
          component={SeguimientoComercialContainer}
        />
        <Route
          path={`${routes.SEGUIMIENTO_COMERCIAL}:id`}
          component={ViewSeguimientoComercialContainer}
        />
        <Route path={routes.CRM} component={SeguimientoComercialContainer} />
        <BreadcrumbProvider>
          <Switch>
            <Route
              path={routes.SEARCH_COMPARE}
              component={SearchCompareContainer}
            />
            {/* CatalogueSearchHost reparte por ruta: la raíz puede llevar el
                motor v2, y todo lo que cuelga de ella sigue yendo al catálogo
                original sin modificar. */}
            <Route
              path={routes.CATALOGUE_V2}
              component={CatalogueSearchHost}
            />
            <Route
              path={routes.PRESENTATION_ADD_PRODUCTS + ':id'}
              component={AddProductToThePresentationFromTheCatalog}
            />
            <Route path='*' component={PageNotFound} />
          </Switch>

          {/* Catalogue  OJO: No poner nada debajo de </BreadcrumbProvider>*/}
        </BreadcrumbProvider>
      </Switch>
    </>
  )
}

export default AppContainer
